module.exports = __webpack_public_path__ + "static/media/Jacob Kowalski 1.654ad134.jpg";